import { createSlice } from '@reduxjs/toolkit';
const InitialState = {};
const registerSlice = createSlice({
    name: 'register',
    initialState: InitialState,
    reducers: {
        addRegisterVariableDocumentation (state, action) {
            state.regvars = action.payload.reduce((acc, item)=>{
                acc[item.shortName] = item;
                return acc;
            }, {});
            return state;
        }
    }
});
const { actions: { addRegisterVariableDocumentation }, reducer } = registerSlice;
export const registerReducer = reducer;
export const RegisterActions = {
    addRegisterVariableDocumentation
};
